module.exports = __webpack_public_path__ + "static/media/joloj.c7eb431d.jpg";